import type { RemoveParentControlsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

const mapTrpcResponseToGraphQL = (
  affectedRows: number
): RemoveParentControlsMutation => {
  return {
    delete_control_parent: {
      __typename: 'control_parent_mutation_response',
      affected_rows: affectedRows,
    },
  };
};

export const useDeleteParentControlsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.control.deleteParents.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.control.register.queryKey(),
        });
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.control.controlsBasic.queryKey(),
        });
      },
    }),
  });

  return {
    deleteParentControls: async (
      parentId: string,
      controlIds: string[]
    ): Promise<RemoveParentControlsMutation> => {
      const result = await mutation.mutateAsync({
        ParentId: parentId,
        ControlIds: controlIds,
      });

      return mapTrpcResponseToGraphQL(result.affected_rows);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
